import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      gap: '10px',
      height: '100%',
      width: '100%'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
